import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { GroupDatesService } from '../../../services/group-dates.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var L: any;
declare var $: any;

@Component({
  selector: 'app-group-dates-list',
  templateUrl: './group-dates-list.component.html',
  styleUrls: ['./group-dates-list.component.css'],
})
export class GroupDatesListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  groupDates: any[] = [];
  filteredDates: any[] = [];
  activeTab: string = 'upcoming';
  loading: boolean = false;
  error: string = '';
  total: number = 10;
  p: number = 1;
  count: number = 0;
  selectedDateId: string = '';
  actionType: string = '';
  groupDateForm: FormGroup = this.initForm();
  status = 'Upcoming';
  submitted: boolean = false;
  isSubmitting: boolean = false;
  selectedImage: File | null = null;
  existingImageUrl: string | null = null;
  private map: any;
  private marker: any;
  private resizeObserver: any;

  constructor(
    private groupDatesService: GroupDatesService,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {}

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  ngOnInit(): void {
    this.loadGroupDates();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initializeMap();
      this.setupResizeObserver();
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.map) {
      this.map.remove();
    }
  }

  private setupResizeObserver(): void {
    const mapContainer = document.getElementById('venueMap');
    if (mapContainer) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      });
      this.resizeObserver.observe(mapContainer);
    }
  }

  private initializeMap(): void {
    const mapContainer = document.getElementById('venueMap');
    if (!mapContainer) {
      console.error('Map container not found');
      return;
    }

    this.map = L.map('venueMap', {
      center: [25.2048, 55.2708],
      zoom: 12,
      zoomControl: true,
      attributionControl: true,
    });

    L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: '&copy; Google Maps',
      maxZoom: 20,
    }).addTo(this.map);

    this.map.on('click', (e: any) => {
      const { lat, lng } = e.latlng;

      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      this.marker = L.marker([lat, lng]).addTo(this.map);

      this.groupDateForm.patchValue({
        latitude: lat.toFixed(6),
        longitude: lng.toFixed(6),
      });
    });

    setTimeout(() => {
      this.map.invalidateSize();
    }, 100);
  }

  searchLocation(): void {
    const searchInput = document.getElementById(
      'locationSearch'
    ) as HTMLInputElement;
    if (searchInput && searchInput.value) {
      const query = searchInput.value;

      fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.length > 0) {
            const { lat, lon, display_name } = data[0];

            this.map.setView([lat, lon], 13);

            if (this.marker) {
              this.map.removeLayer(this.marker);
            }

            this.marker = L.marker([lat, lon]).addTo(this.map);

            this.groupDateForm.patchValue({
              latitude: lat,
              longitude: lon,
            });
          }
        })
        .catch((error) => {
          console.error('Error searching location:', error);
        });
    }
  }

  loadGroupDates(): void {
    this.loading = true;
    this.error = '';

    this.groupDatesService.getGroupDates({}).subscribe({
      next: (response) => {
        this.groupDates = response.data || [];
        this.filterDates();
        this.loading = false;
      },
      error: (error) => {
        this.error = 'Failed to load group dates. Please try again later.';
        this.loading = false;
        console.error('Error loading group dates:', error);
      },
    });
  }

  selectTab(tab: string): void {
    this.activeTab = tab;
    this.filterDates();
  }

  filterDates(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (this.activeTab) {
      case 'upcoming':
        this.filteredDates = this.groupDates.filter((date) => {
          return date.status == 'Upcoming';
        });
        break;

      case 'open':
        this.filteredDates = this.groupDates.filter(
          (date) =>
            date.status === 'Open' ||
            date.status === 'Closed' ||
            date.status === 'Confirmed'
        );
        break;

      case 'completed':
        this.filteredDates = this.groupDates.filter(
          (date) => date.status === 'Completed'
        );
        break;

      default:
        this.filteredDates = this.groupDates;
    }

    this.count = this.filteredDates.length;
    this.p = 1;
  }

  onTableDataChange(event: any): void {
    this.p = event;
  }

  onKeyUpEvent(event: any): void {
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.filteredDates = this.groupDates.filter(
        (date) =>
          date.venue_name.toLowerCase().includes(searchTerm) ||
          date.address.toLowerCase().includes(searchTerm) ||
          date.status.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filterDates();
    }
  }

  onAddGroupDateClick() {
    this.resetForm();
    $('#groupDateModal').modal('show');
  }

  openModal(id: string, action: string): void {
    this.selectedDateId = id;
    this.actionType = action;
  }

  openDeleteModal(date: any): void {
    this.selectedDateId = date.id;
    $('#deleteDateModal').modal('show');
  }

  deleteDate(): void {
    if (!this.selectedDateId) return;

    this.groupDatesService.deleteGroupDate(this.selectedDateId).subscribe({
      next: (response) => {
        console.log('Group date deleted successfully:', response);
        $('#deleteDateModal').modal('hide');
        this.loadGroupDates();
        this.selectedDateId = '';
      },
      error: (error) => {
        console.error('Error deleting group date:', error);
      },
    });
  }

  viewAttendees(id: string): void {
    this.router.navigate(['/group-dates', id, 'attendees']);
  }

  private initForm(): FormGroup {
    return this.formBuilder.group({
      title: ['', Validators.required],
      description: [''],
      max_participants: [
        6,
        [Validators.required, Validators.min(2), Validators.max(100)],
      ],
      max_participants_limit: [
        6,
        [Validators.required, Validators.min(2), Validators.max(100)],
      ],
      slot_date: ['', Validators.required],
      slot_opens_at: ['', Validators.required],
      invites_sent_at: ['', Validators.required],
      slot_closes_after: [
        24,
        [Validators.required, Validators.min(1), Validators.max(168)],
      ],
      venue_name: ['', Validators.required],
      neighborhood: [''],
      address: ['', Validators.required],
      latitude: [
        '',
        [Validators.required, Validators.min(-90), Validators.max(90)],
      ],
      longitude: [
        '',
        [Validators.required, Validators.min(-180), Validators.max(180)],
      ],
      reservation_name: ['Maxion'],
      is_public: [false],
      status: ['Upcoming'],
    });
  }

  get f() {
    return this.groupDateForm.controls;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedImage = file;
      this.existingImageUrl = null;
    }
  }

  onEditGroupDateClick(date: any): void {
    console.log(date);
    this.selectedDateId = date.id;
    this.existingImageUrl = date.photo || null;
    const formData = {
      title: date.title || '',
      description: date.description || '',
      max_participants: date.max_participants || 1,
      max_participants_limit: date.max_participants_limit || 1,
      slot_date: this.formatDateTimeForInput(date.slot_date, date.slot_time),
      slot_opens_at: this.formatDateForInput(date.slot_opens_at),
      invites_sent_at: this.formatDateForInput(date.invites_sent_at),
      slot_closes_after: date.slot_closes_after || 24,
      status: date.status,
      venue_name: date.venue_name || '',
      neighborhood: date.neighborhood || '',
      address: date.address || '',
      reservation_name: date.reservation_name || '',
      is_public: date.is_public ? true : false,
      latitude: date.latitude || '',
      longitude: date.longitude || '',
    };

    this.groupDateForm.patchValue(formData);

    // Set map location if latitude and longitude exist
    if (date.latitude && date.longitude) {
      const lat = parseFloat(date.latitude);
      const lng = parseFloat(date.longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        this.map.setView([lat, lng], 13);

        if (this.marker) {
          this.map.removeLayer(this.marker);
        }

        this.marker = L.marker([lat, lng]).addTo(this.map);
      }
    }

    $('#groupDateModal').modal('show');
  }

  private formatDateTimeForInput(date: string, time: string): string {
    try {
      if (!date) return '';
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) return '';

      if (time) {
        const [hours, minutes] = time.split(':');
        dateObj.setHours(parseInt(hours) || 0, parseInt(minutes) || 0);
      }

      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
      console.error('Error formatting date time:', error);
      return '';
    }
  }

  private formatDateForInput(date: string): string {
    try {
      if (!date) return '';
      const dateObj = new Date(date);
      if (isNaN(dateObj.getTime())) return '';
      console.log('date', dateObj.toDateString());

      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.groupDateForm.invalid) {
      return;
    }

    this.isSubmitting = true;

    const formData = new FormData();

    Object.keys(this.groupDateForm.value).forEach((key) => {
      if (key === 'slot_date') {
        formData.append(key, this.groupDateForm.value[key]);
        formData.append(
          'slot_time',
          this.groupDateForm.value[key].split('T')[1]
        );
      } else {
        formData.append(key, this.groupDateForm.value[key]);
      }
    });

    if (this.selectedImage) {
      formData.append('image', this.selectedImage);
    }

    if (this.selectedDateId) {
      formData.append('id', this.selectedDateId);
    }

    const action = this.selectedDateId ? 'update' : 'create';

    this.groupDatesService[
      action === 'create' ? 'createGroupDate' : 'updateGroupDate'
    ](formData).subscribe({
      next: (response: any) => {
        console.log(`Group date ${action}d successfully:`, response);
        $('#groupDateModal').modal('hide');
        this.loadGroupDates();
        this.resetForm();
      },
      error: (error: any) => {
        console.error(`Error ${action}ing group date:`, error);
        this.resetForm();
        $('#groupDateModal').modal('hide');
        this.isSubmitting = false;
        this.submitted = false;
        alert('Something went wrong, Contact backend dev');
      },
      complete: () => {
        this.isSubmitting = false;
        this.submitted = false;
      },
    });
  }

  private resetForm(): void {
    this.submitted = false;
    this.selectedImage = null;
    this.existingImageUrl = null;
    this.selectedDateId = '';
    this.groupDateForm = this.initForm();

    // Clear file input
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    // Clear search location input
    const searchInput = document.getElementById(
      'locationSearch'
    ) as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }

    // Reset map to default view
    if (this.map) {
      this.map.setView([25.2048, 55.2708], 12);
      if (this.marker) {
        this.map.removeLayer(this.marker);
        this.marker = null;
      }
    }
  }
}
